export default {
  'financial.billsToPay.label.status': 'Status',
  'financial.billsToPay.label.filterByDate': 'Filter by date',
  'financial.billsToPay.label.reportType': 'Select report type',
  'financial.billsToPay.label.show': 'Show:',
  'financial.billsToPay.label.moreOptions': 'More Options',
  'financial.billsToPay.label.accountPlans': 'Account Plans',
  'financial.billsToPay.label.documentType': 'Document Type',
  'financial.billsToPay.label.costCenter': 'Cost Center',
  'financial.billsToPay.label.bankAccount': 'Bank Account',

  'financial.billsToPay.option.open': 'Open',
  'financial.billsToPay.option.liquidated': 'Liquidated',
  'financial.billsToPay.option.emission': 'Emission',
  'financial.billsToPay.option.expiration': 'Expiration',
  'financial.billsToPay.option.payment': 'Payment',
  'financial.billsToPay.option.accountPlans': 'Account Plans',
  'financial.billsToPay.option.bankAccount': 'Bank Account',

  'financial.billsToPay.checkbox.synthetic': 'Synthetic?',
  'financial.billsToPay.checkbox.billsToPay': 'bills to pay',
  'financial.billsToPay.checkbox.tariffs': 'Tariffs',

  'financial.billsToPay.button.selectSuppliers': 'Select Suppliers',
  'financial.billsToPay.button.selectEmployees': 'Select Employees',

  'domain.enums.situation_installment_payable.open': 'Open',
  'domain.enums.situation_installment_payable.settled': 'Settled',

  'financial.billsToPay.create.success.title': 'Success',
  'financial.billsToPay.create.success.content':
    'Installment created successfully!',

  'financial.billsToPay.update.success.title': 'Success',
  'financial.billsToPay.update.success.content':
    'Accounts payable updated successfully!',

  'financial.billsToPay.cancel.success.title': 'Confirmation',
  'financial.billsToPay.cancel.success.content':
    'The parcel deletion process is irreversible. Do you really want to delete the parcel?',
  'financial.billsToPay.cancel.success.content.commision':
    'When deleting the last installment of the account payable linked to the commission, the amount will be automatically refunded. Do you want to continue with the deletion?',
  'financial.billsToPay.notifications.remove.success.title': 'Success!',
  'financial.billsToPay.notifications.remove.success.description':
    'Parcel has been deleted successfully!',

  'financial.billsToPay.detail.button.newAccountPayable': 'New Account Payable',
  'financial.billsToPay.detail.button.parcel': 'Parcel',
  'financial.billsToPay.detail.button.renegotiate': 'Renegotiate',
  'financial.billsToPay.detail.button.observation': 'New Observation',
  'financial.billsToPay.detail.button.observationSave': 'Save Note',
  'financial.billsToPay.detail.button.observationEdit': 'Edit Note',
  'financial.billsToPay.detail.button.settleInstallment': 'Settle Installment',
  'financial.billsToPay.detail.button.partiallyLiquidate': 'Partially Settle',
  'financial.billsToPay.detail.button.reverseInstallment':
    'Reverse Installment',

  'financial.billsToPay.notifications.settledSingle.success.title': 'Success!',
  'financial.billsToPay.notifications.settledSingle.success.description':
    'Installment was settled successfully',

  'financial.billsToPay.notifications.settledPartially.success.title':
    'Success!',
  'financial.billsToPay.notifications.settledPartially.success.description':
    'Installment was partially settled successfully',

  'financial.billsToPay.notifications.settledMultiple.success.title':
    'Success!',
  'financial.billsToPay.notifications.settledMultiple.success.description':
    'Installments settled successfully!',

  'financial.billsToPay.notifications.splitInstallment.success.title':
    'Success!',
  'financial.billsToPay.notifications.splitInstallment.success.description':
    'Installment of the installment made successfully!',

  'financial.billsToPay.notifications.renegotiateInstallment.success.title':
    'Success!',
  'financial.billsToPay.notifications.renegotiatInstallment.success.description':
    'Renegotiation successful!',
};
